import { useBrandView } from "@faire/retailer-visitor-shared/views/brand/hooks/useBrandView";
export var useBrand = function() {
    var _useBrandView;
    return (_useBrandView = useBrandView()) === null || _useBrandView === void 0 ? void 0 : _useBrandView.brand;
};
